import React, {useEffect, useRef, useState} from "react";
import Header from "../../components/header/header";
import styles from "../../styles/dashboard.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight, faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import officeStyles from './offices.module.css';
import axiosInstance from "../../AxiosInstance";
import PageTitle from "../../components/page_title/page_title";
import Modal from "../../components/modal/modal";
import {TextInput} from "../../components/input/inputs";
import {useTranslation} from "react-i18next";

function OfficeActions({office, setShowEditModal, setEditForm, setShowDeleteModal, setSelectedOffice, setShowPopup}) {
    const {t} = useTranslation();
    return (
        <div style={{width: '200px', height: 'auto'}}>
            <div className={officeStyles.popupButton} onClick={() => {
                setEditForm({id: office.id, name: office.name});
                setSelectedOffice(office);
                setShowEditModal(true);
                setShowPopup(false);
            }}>
                <FontAwesomeIcon icon={faEdit} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>{t('common.edit')}</div>
            </div>
            <div className={officeStyles.popupButton} onClick={() => {
                setSelectedOffice(office);
                setShowDeleteModal(true);
                setShowPopup(false);
            }}>
                <FontAwesomeIcon icon={faTrash} color={'#f64a4a'} className={'me-2'}/>
                <div style={{color: '#f64a4a'}}>{t('common.delete')}</div>
            </div>
        </div>
    );
}

function OfficeObject({office, setShowPopup, setMousePosition, setSelectedOffice}) {
    const changeOffice = () => {
        localStorage.setItem('project', JSON.stringify(office));
        localStorage.setItem('project_id', office.id);
        window.location.reload();
    }

    return (
        <div className={`${officeStyles.office}`} onClick={() => changeOffice()} onContextMenu={(event) => {
            event.preventDefault();
            setMousePosition({ x: event.clientX, y: event.clientY });
            setSelectedOffice(office);
            setShowPopup(true);
        }}>
            <div className={'d-flex justify-content-between'}>
                <div style={{backgroundColor: "#F1F5F9", padding: "6px 10px", borderRadius: "6px"}}>
                    <img alt={'office'} height={'18px'} src={'/hut.png'}/>
                </div>
                <FontAwesomeIcon icon={faArrowRight}/>
            </div>
            <div>{office.name}</div>
        </div>
    );
}

export default function Offices() {
    const {t} = useTranslation();
    const [officesList, setOfficesList] = useState(JSON.parse(localStorage.getItem('offices')) || []);
    const company_id = localStorage.getItem('company_id');
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({company_id: company_id});

    // Edit/Delete states
    const [showPopup, setShowPopup] = useState(false);
    const [mousePosition, setMousePosition] = useState({x: 0, y: 0});
    const [selectedOffice, setSelectedOffice] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editForm, setEditForm] = useState({});
    const popupRef = useRef(null);

    const refreshOffices = () => {
        axiosInstance.get(`project/?company_id=${company_id}`).then((res) => {
            localStorage.setItem('offices', JSON.stringify(res.data));
            setOfficesList(res.data);
        });
    };

    useEffect(() => {
        refreshOffices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createOffice = () => {
        axiosInstance.post('project/', form).then((response) => {
            refreshOffices();
            setShowModal(false);
            setForm({company_id: company_id});
        });
    };

    const updateOffice = () => {
        axiosInstance.put(`project/${editForm.id}/`, {
            name: editForm.name
        }).then(() => {
            refreshOffices();
            setShowEditModal(false);
            setEditForm({});
        }).catch((err) => {
            console.error('Error updating office:', err);
        });
    };

    const deleteOffice = () => {
        const deletedOfficeId = selectedOffice.id;
        const currentProjectId = parseInt(localStorage.getItem('project_id'));

        axiosInstance.delete(`project/${deletedOfficeId}/`).then(() => {
            // Refresh the offices list
            axiosInstance.get(`project/?company_id=${company_id}`).then((res) => {
                const updatedOffices = res.data || [];
                localStorage.setItem('offices', JSON.stringify(updatedOffices));
                setOfficesList(updatedOffices);

                // If the deleted office was the current project, switch to another one
                if (currentProjectId === deletedOfficeId) {
                    if (updatedOffices.length > 0) {
                        // Switch to the first available office
                        const newProject = updatedOffices[0];
                        localStorage.setItem('project', JSON.stringify(newProject));
                        localStorage.setItem('project_id', newProject.id);
                    } else {
                        // No offices left, clear the project
                        localStorage.removeItem('project');
                        localStorage.removeItem('project_id');
                    }
                    window.location.reload();
                }

                setShowDeleteModal(false);
                setSelectedOffice(null);
            });
        }).catch((err) => {
            console.error('Error deleting office:', err);
        });
    };

    // Handle outside click for popup
    const handleOutsideClick = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    useEffect(() => {
        if (showPopup) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showPopup]);

    return (
        <div className={styles.dashboard_container}>
            <Header sidebarIndex={3}/>

            {/* Popup for Edit/Delete */}
            {showPopup && selectedOffice &&
                <div ref={popupRef} className={officeStyles.popUpModule} style={{top: mousePosition.y + 10, left: mousePosition.x, position: 'absolute', zIndex: '100000'}}>
                    <OfficeActions
                        office={selectedOffice}
                        setShowEditModal={setShowEditModal}
                        setEditForm={setEditForm}
                        setShowDeleteModal={setShowDeleteModal}
                        setSelectedOffice={setSelectedOffice}
                        setShowPopup={setShowPopup}
                    />
                </div>
            }

            {/* Create Modal */}
            <Modal show={showModal} setter={setShowModal} name={t('offices.createOffice')} onClick={createOffice} buttonName={t('offices.createOffice')}>
                <TextInput form={form} setForm={setForm} name={'name'} placeholder={t('offices.officeName')}/>
            </Modal>

            {/* Edit Modal */}
            <Modal show={showEditModal} setter={setShowEditModal} name={t('common.edit')} onClick={updateOffice} buttonName={t('common.save')}>
                <TextInput form={editForm} setForm={setEditForm} name={'name'} placeholder={t('offices.officeName')}/>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} setter={setShowDeleteModal} name={t('common.delete')} onClick={deleteOffice} buttonName={t('common.delete')}>
                <div style={{textAlign: 'center', padding: '20px 0'}}>
                    <div style={{fontSize: '16px', color: '#1E293B', marginBottom: '12px'}}>
                        Are you sure you want to delete <strong>{selectedOffice?.name}</strong>?
                    </div>
                    <div style={{fontSize: '14px', color: '#64748B'}}>
                        This action cannot be undone. All data associated with this office will be permanently deleted.
                    </div>
                </div>
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <PageTitle title={t('offices.title')} openModal={setShowModal} createName={t('offices.officeName')}/>

                <div className={`${officeStyles.officeContainer} mt-4`}>
                    {officesList.map((office, index) => (
                        <OfficeObject
                            office={office}
                            key={index}
                            setShowPopup={setShowPopup}
                            setMousePosition={setMousePosition}
                            setSelectedOffice={setSelectedOffice}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
